import React from 'react';

import isPWA from './isPWA';

const smallScreenWidth = 768;

const useAddToHomescreenPrompt = () => {
  const [prompt, setState] = React.useState(null);

  const promptToInstall = () => {
    if (prompt) {
      setState(null);
      return prompt.prompt();
    }
    return Promise.reject(
      new Error(
        'Tried installing before browser sent "beforeinstallprompt" event',
      ),
    );
  };

  React.useEffect(() => {
    // hide in pwa or small screen width
    if (isPWA() || window.innerWidth > smallScreenWidth) {
      return;
    }
    const ready = (e) => {
      e.preventDefault();
      setState(e);
    };

    window.addEventListener('beforeinstallprompt', ready);
    return () => {
      window.removeEventListener('beforeinstallprompt', ready);
    };
  }, []);

  return [prompt, promptToInstall];
};

export default useAddToHomescreenPrompt;
